import React from 'react';
import { IN_STOCK } from 'components/common/Routes';
import { Link, withRouter } from 'react-router-dom';

class Settings extends React.PureComponent {
  render() {
    let url = `/${IN_STOCK}`;
    return (
      <div>
        Settings{' '}
        <button onClick={() => this.props.history.push(IN_STOCK)}>
          Go to home
        </button>
      </div>
    );
  }
}

export default withRouter(Settings);
